import { render, staticRenderFns } from "./MessageManager.vue?vue&type=template&id=1f10f12c&scoped=true&"
import script from "./MessageManager.vue?vue&type=script&lang=js&"
export * from "./MessageManager.vue?vue&type=script&lang=js&"
import style0 from "./MessageManager.vue?vue&type=style&index=0&id=1f10f12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f10f12c",
  null
  
)

export default component.exports